import React from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import Common from 'helpers/intl-common';
import { Button } from '@companycam/slab-web';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  position: sticky;
  padding-top: 7px;
  padding-bottom: 10px;
  padding-right: 6px;
`;

type ClearButtonProps = {
  onClick: () => void;
  dataTestId: string;
};
const ClearButton = ({ onClick, dataTestId }: ClearButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <Container onClick={onClick}>
      <Button color="subtle" design="minimal" data-testid={dataTestId}>
        {formatMessage(Common.clear)}
      </Button>
    </Container>
  );
};

export default ClearButton;
